if(window.gsap && window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

/* Preloader */
window.addEventListener('load',()=>{
  setTimeout(()=>{
    const pre=document.getElementById('preloader');
    if(pre) pre.classList.add('done');
    document.body.classList.remove('loading');
  },100);
});

/* Nav scroll state */
const header=document.getElementById('header');
if(header) addEventListener('scroll',()=>header.classList.toggle('scrolled',scrollY>40));

/* ================= Hero slider (home only) ================= */
(function(){
  const root=document.getElementById('heroSlider');
  if(!root) return;
  const slides=[...root.querySelectorAll('.hero-slide')];
  const navBtns=[...root.querySelectorAll('.hero-nav button')];
  const bars=[...root.querySelectorAll('.hero-progress .bar')];
  const eyebrowEl=root.querySelector('[data-anim="eyebrow"]');
  const outlineEl=root.querySelector('[data-anim="outline"]');
  const solidEl=root.querySelector('[data-anim="solid"]');
  const emEl=root.querySelector('[data-anim="em"]');
  const ledeEl=root.querySelector('[data-anim="lede"]');
  const DURATION=6000;
  let idx=0, timer=null, barTween=null, playing=true;

  function setText(s){
    eyebrowEl.textContent=s.dataset.eyebrow;
    outlineEl.textContent=s.dataset.outline;
    solidEl.childNodes[0].nodeValue=s.dataset.solid+' ';
    emEl.textContent=s.dataset.em;
    ledeEl.textContent=s.dataset.lede;
  }

  function animateText(){
    const tl=gsap.timeline();
    tl.fromTo([eyebrowEl,outlineEl,solidEl,ledeEl],
      {opacity:0,y:22},
      {opacity:1,y:0,duration:.7,ease:'power3.out',stagger:.08},0)
      .fromTo(emEl,{opacity:0,y:22},{opacity:1,y:0,duration:.7,ease:'power3.out'},0.08);
  }

  function goTo(next){
    if(next===idx) return;
    const cur=slides[idx], nxt=slides[next];
    gsap.to(cur.querySelector('img'),{scale:1.14,duration:.9,ease:'power2.out'});
    gsap.set(nxt,{zIndex:2});
    gsap.set(nxt.querySelector('img'),{scale:1.14});
    gsap.to(nxt,{opacity:1,visibility:'visible',duration:.9,ease:'power2.inOut',
      onStart:()=>nxt.classList.add('is-active'),
      onComplete:()=>{cur.classList.remove('is-active');gsap.set(cur,{opacity:0,visibility:'hidden',zIndex:0});gsap.set(nxt,{zIndex:1});}});
    gsap.fromTo(nxt.querySelector('img'),{scale:1.14},{scale:1.04,duration:6,ease:'none'});
    setText(nxt);
    animateText();
    navBtns.forEach((b,i)=>b.classList.toggle('active',i===next));
    bars.forEach((b,i)=>{
      b.classList.toggle('done',i<next);
      if(i===next){b.classList.remove('done');const bb=b.querySelector('b');gsap.set(bb,{width:'0%'});}
      if(i>next){const bb=b.querySelector('b');gsap.set(bb,{width:'0%'});b.classList.remove('done');}
    });
    idx=next;
    startBar();
  }

  function startBar(){
    if(barTween) barTween.kill();
    const bb=bars[idx].querySelector('b');
    gsap.set(bb,{width:'0%'});
    barTween=gsap.to(bb,{width:'100%',duration:DURATION/1000,ease:'none',
      onComplete:()=>{ if(playing) goTo((idx+1)%slides.length); }});
  }

  navBtns.forEach((b,i)=>b.addEventListener('click',()=>goTo(i)));
  bars.forEach((b,i)=>b.addEventListener('click',()=>goTo(i)));

  root.addEventListener('mouseenter',()=>{playing=false;barTween&&barTween.pause();});
  root.addEventListener('mouseleave',()=>{playing=true;barTween&&barTween.resume();});

  gsap.set(slides[0].querySelector('img'),{scale:1.14});
  gsap.fromTo(slides[0].querySelector('img'),{scale:1.14},{scale:1.04,duration:6,ease:'none',delay:.3});
  startBar();
})();

/* Scroll reveal (all pages) */
const io=new IntersectionObserver((es)=>{
  es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
},{threshold:.16,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('[data-reveal]').forEach(el=>io.observe(el));

/* GSAP scroll parallax — editorial image + full-bleed bands (guarded, no-op if absent) */
if(window.gsap && window.ScrollTrigger){
  if(document.querySelector('#parallaxImg')){
    gsap.to('#parallaxImg',{yPercent:-10,ease:'none',
      scrollTrigger:{trigger:'#editorial',start:'top bottom',end:'bottom top',scrub:.6}});
  }
  gsap.utils.toArray('[data-parallax]').forEach(img=>{
    gsap.fromTo(img,{yPercent:-8},{yPercent:8,ease:'none',
      scrollTrigger:{trigger:img.closest('.parallax-band'),start:'top bottom',end:'bottom top',scrub:.6}});
  });
  gsap.utils.toArray('.parallax-band').forEach(band=>{
    gsap.from(band.querySelectorAll('.pb-content > *'),{
      opacity:0,y:36,duration:.8,stagger:.12,ease:'power2.out',
      scrollTrigger:{trigger:band,start:'top 70%',toggleActions:'play none none reverse'}});
  });
  if(document.querySelector('.page-hero')){
    gsap.to('.page-hero .ph-img img',{yPercent:10,ease:'none',
      scrollTrigger:{trigger:'.page-hero',start:'top top',end:'bottom top',scrub:.6}});
  }
}

/* Magnetic primary buttons */
document.querySelectorAll('.btn-primary').forEach(btn=>{
  btn.addEventListener('mousemove',e=>{const r=btn.getBoundingClientRect();
    btn.style.transform='translate('+((e.clientX-r.left-r.width/2)*.18)+'px,'+((e.clientY-r.top-r.height/2)*.28)+'px)';});
  btn.addEventListener('mouseleave',()=>btn.style.transform='');
});

/* Mobile menu */
const mm=document.getElementById('mobileMenu');
const burger=document.getElementById('burger');
const closeMenu=document.getElementById('closeMenu');
if(mm&&burger){
  burger.onclick=()=>mm.classList.add('open');
  closeMenu&&(closeMenu.onclick=()=>mm.classList.remove('open'));
  mm.querySelectorAll('a').forEach(a=>a.onclick=()=>mm.classList.remove('open'));
}

/* Product gallery/swatch/size/qty wiring, shop filter pills, and cart-row
   quantity/remove logic are all data-driven now (see assets/store.js and
   each page's own inline script, which run after the product/cart data
   is rendered into the DOM). Nothing generic to bind here anymore. */

document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname.replace(/\/$/, "");

  document.querySelectorAll(".menu a").forEach(function (link) {
    const linkPath = new URL(link.href, window.location.origin)
      .pathname
      .replace(/\/$/, "");

    if (linkPath === currentPath) {
      link.classList.add("is-active");
    } else {
      link.classList.remove("is-active");
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const mainImg = document.getElementById('pdpMainImg');
  const colorNameDisplay = document.getElementById('pdpColorName');
  const swatches = document.querySelectorAll('.swatch');
  const pdpThumbs = document.querySelectorAll('.pdp-thumb-btn');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      // 1. Remove 'active' class from all swatches, add to the clicked one
      swatches.forEach(s => s.classList.remove('active'));
      this.classList.add('active');

      // 2. Update the color name label text (e.g., changes "Rose Red" to "Black")
      const colorValue = this.getAttribute('data-value');
      if (colorNameDisplay && colorValue) {
        colorNameDisplay.textContent = colorValue;
      }

      // 3. Update the main image source
      const newImgSrc = this.getAttribute('data-image-src');
      if (mainImg && newImgSrc) {
        mainImg.src = newImgSrc;
        
        // 4. Sync the active state on the thumbnail gallery
        if (pdpThumbs.length > 0) {
          pdpThumbs.forEach(thumb => {
            const thumbSrc = thumb.getAttribute('data-img-src');
            if (thumbSrc === newImgSrc) {
              thumb.classList.add('active');
            } else {
              thumb.classList.remove('active');
            }
          });
        }
      }
    });
  });
});